import { TypeOf, array, coerce, nativeEnum, object, string, union, instanceof as zInstanceof } from 'zod';
import { ICompany } from 'Models/Company';
import { IPointOfSale } from 'Models/PointOfSale';
import { ISelectOption } from 'Interfaces/Utils';
import { IUser } from 'Models/User';

// Form component interface

export interface IPointOfSaleFormProps {
  companies: ISelectOption<string>[];
  provinces: ISelectOption<string>[];
  apiError: any;
  currentPointOfSale?: IPointOfSale;
  onSubmit: (formData: FormData) => void;
};


// Form fields

export const FIELDS = {
  NAME: {
    FIELD: 'name',
    LABEL: 'pointOfSale.name',
    ERROR: 'Nombre del punto de venta obligatorio',
  },
  ADDRESS_TYPE: {
    FIELD: 'addressType',
    LABEL: 'pointOfSale.addressType',
    ERROR: 'Tipo de vía obligatorio',
  },
  ADDRESS_NAME: {
      FIELD: 'addressName',
      LABEL: 'pointOfSale.addressName',
      ERROR: 'Nombre de la vía obligatorio',
    },
  ADDRESS_NUMBER: {
      FIELD: 'addressNumber',
      LABEL: 'pointOfSale.addressNumber',
      ERROR: 'Número obligatorio',
    },
  ADDRESS_DETAILS: {
      FIELD: 'addressDetails',
      LABEL: 'pointOfSale.addressDetails',
      ERROR: 'Detalles adicionales obligatorios si aplican',
    },
  POSTAL_CODE: {
      FIELD: 'postalCode',
      LABEL: 'pointOfSale.postalCode',
      ERROR: 'Código Postal obligatorio',
    },
  PROVINCE: {
      FIELD: 'province',
      LABEL: 'pointOfSale.province',
      ERROR: 'Provincia obligatoria',
    },
  LOCALITY: {
      FIELD: 'locality',
      LABEL: 'pointOfSale.locality',
      ERROR: 'Localidad obligatoria',
    },  
  IMAGE: {
    FIELD: 'image',
  },
  COMPANY: {
    FIELD: 'companyId',
    LABEL: 'pointOfSale.company',
    ERROR: 'Empresa obligatoria',
  },
};

// Form validation schema

export const pointOfSaleFormSchema = object({
  [FIELDS.NAME.FIELD]: string().min(1, { message: FIELDS.NAME.ERROR }),
  [FIELDS.ADDRESS_TYPE.FIELD]: string().min(1, { message: FIELDS.ADDRESS_TYPE.ERROR }),
  [FIELDS.ADDRESS_NAME.FIELD]: string().min(1, { message: FIELDS.ADDRESS_NAME.ERROR }),
  [FIELDS.ADDRESS_NUMBER.FIELD]: string().min(1, { message: FIELDS.ADDRESS_NUMBER.ERROR }),
  [FIELDS.ADDRESS_DETAILS.FIELD]: string().optional(),
  [FIELDS.POSTAL_CODE.FIELD]: string().min(1, { message: FIELDS.POSTAL_CODE.ERROR }),
  [FIELDS.PROVINCE.FIELD]: string().min(1, { message: FIELDS.PROVINCE.ERROR }),
  [FIELDS.COMPANY.FIELD]: string().min(1, { message: FIELDS.COMPANY.ERROR }),
  [FIELDS.IMAGE.FIELD]: union([string(), zInstanceof(File)]).optional(),
  [FIELDS.LOCALITY.FIELD]: string().min(1, { message: FIELDS.LOCALITY.ERROR }),
});

// Form values interface

export type IPointOfSaleForm = TypeOf<typeof pointOfSaleFormSchema>;

// Default values function

export const initialValues = (pointOfSale: IPointOfSale| undefined, user:IUser| undefined): IPointOfSaleForm => {
  const newsForm: IPointOfSaleForm = {
    name: pointOfSale?.name || "",
    addressType: pointOfSale?.addressType || "",
    addressName: pointOfSale?.addressName || "",
    addressNumber: pointOfSale?.addressNumber || "",
    addressDetails: pointOfSale?.addressDetails || "",
    postalCode: pointOfSale?.postalCode || "",
    province: pointOfSale?.province || "",
    companyId: pointOfSale?.companyId || user?.companyId,
    locality: pointOfSale?.locality || "",
  };

  return newsForm;
};